module.exports = __webpack_public_path__ + "img/sideseam.594b5404.png";